<form
  (submit)="onSubmit($event)"
  (keydown.escape)="discard.emit()"
  class="flex flex-col gap-2 py-1">
  <input
    #titleInput
    type="text"
    [value]="draft().title"
    (input)="titleChange.emit($any($event.target).value)"
    [attr.aria-label]="'dossierDetail.newFolderLabel' | translate"
    [placeholder]="'dossierDetail.newFolderPlaceholder' | translate"
    class="w-full rounded-md border border-gray-300 bg-white p-2 text-sm text-cmi-gray" />

  <div class="flex gap-3 text-xs">
    <button
      type="submit"
      [disabled]="!draft().title.trim()"
      class="cursor-pointer font-medium text-main hover:underline disabled:cursor-not-allowed disabled:text-cmi-gray-mid disabled:no-underline">
      {{ 'dossierDetail.newFolderAdd' | translate }}
    </button>
    <button
      type="button"
      (click)="discard.emit()"
      class="cursor-pointer text-cmi-gray-mid hover:text-main hover:underline">
      {{ 'dossierDetail.newFolderCancel' | translate }}
    </button>
  </div>
</form>
